import { BankFormState } from "shared/utils/fieldsHelper/companyFields";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { isNullOrEmptyString } from "shared/utils";

export const bankDetailsSection = (
  existingBank: BankFormState,
  sourceBank: BankFormState,
  currentBank: BankFormState,
  setCurrentBank: (bank: BankFormState) => void
): MergeFormSection => {
  const hasBankDetails = !isNullOrEmptyString(currentBank.accountNumber);
  return {
    key: "bankDetails",
    title: RESX.BankAccount.BankAccountDetails,
    fields: [{
      key: "accountNumber",
      label: RESX.BankAccount.AccountNumber,
      currentValue: currentBank.accountNumber,
      existingValue: existingBank.accountNumber,
      sourceValue: sourceBank.accountNumber,
      isEmpty: (v) => !v,
      render: (v) => <span>{v}</span>,
      onSourceClick: () => setCurrentBank({
        ...currentBank,
        accountNumber: sourceBank.accountNumber,
      }),
      onExistingClick: () => setCurrentBank({
        ...currentBank,
        accountNumber: existingBank.accountNumber,
      }),
    }, {
      key: "beneficiaryName",
      label: RESX.BankAccount.BeneficiaryName,
      hidden: !hasBankDetails,
      currentValue: currentBank.beneficiaryName,
      existingValue: existingBank.beneficiaryName,
      sourceValue: sourceBank.beneficiaryName,
      isEmpty: (v) => !v,
      render: (v) => <span>{v}</span>,
      onSourceClick: () => setCurrentBank({
        ...currentBank,
        beneficiaryName: sourceBank.beneficiaryName,
      }),
      onExistingClick: () => setCurrentBank({
        ...currentBank,
        beneficiaryName: existingBank.beneficiaryName,
      }),
    }, {
      key: "swiftCode",
      label: RESX.BankAccount.SwiftCode,
      hidden: !hasBankDetails,
      currentValue: currentBank.swiftCode,
      existingValue: existingBank.swiftCode,
      sourceValue: sourceBank.swiftCode,
      isEmpty: (v) => !v,
      render: (v) => <span>{v}</span>,
      onSourceClick: () => setCurrentBank({
        ...currentBank,
        swiftCode: sourceBank.swiftCode,
      }),
      onExistingClick: () => setCurrentBank({
        ...currentBank,
        swiftCode: existingBank.swiftCode,
      }),
    }, {
      key: "sortCode",
      label: RESX.BankAccount.BsbNumber,
      hidden: !hasBankDetails,
      currentValue: currentBank.sortCode,
      existingValue: existingBank.sortCode,
      sourceValue: sourceBank.sortCode,
      isEmpty: (v) => !v,
      render: (v) => <span>{v}</span>,
      onSourceClick: () => setCurrentBank({
        ...currentBank,
        sortCode: sourceBank.sortCode,
      }),
      onExistingClick: () => setCurrentBank({
        ...currentBank,
        sortCode: existingBank.sortCode,
      }),
    }, {
      key: "bankAddress",
      label: RESX.BankAccount.Bank,
      hidden: !hasBankDetails,
      currentValue: currentBank.bankAddress,
      existingValue: existingBank.bankAddress,
      sourceValue: sourceBank.bankAddress,
      isEmpty: (v) => !v,
      render: (v) => <span>{v}</span>,
      onSourceClick: () => setCurrentBank({
        ...currentBank,
        bankAddress: sourceBank.bankAddress,
      }),
      onExistingClick: () => setCurrentBank({
        ...currentBank,
        bankAddress: existingBank.bankAddress,
      }),
    }]
  }
}